import { Injectable, Inject } from "@angular/core";
import {AuthenticationAbstractService} from "./abstract/authentication.abstract.service";
import {Credentials} from "../components/domain/credentials";
import {TokenCredential} from "../components/domain/tokenCredential";
import {Status} from "../components/domain/status";
import {RestAbstractService} from "./abstract/rest.abstract.service";
import {RestService} from "./rest.service";
import { HttpClient } from '@angular/common/http';
import { take, catchError, map } from 'rxjs/operators';
import { RequestResult } from 'app/tsModels/RequestResult';
import { Observable, of as observableOf } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable()
export class LoginService {

    constructor(
        private restAbstractService: RestAbstractService,
        @Inject(RestService) private restService: RestAbstractService,
        private http: HttpClient,
        //@Inject("AuthV2") private authV2Service: AuthenticationAbstractService,
        @Inject("Auth") private authAbstractService: AuthenticationAbstractService
    ) {}

    API = environment.apiV3Url;

    public login(credentials: Credentials, success: () => void, error: (status: Status) => void): void{
        // this.restService.post<any>('login', null, credentials).subscribe(
        //     (data) => {
        //this.authV2Service.token = data.authToken;
        this.login_umotion(credentials, success, error);
        //     },
        //     (err) => {
        //         const json = JSON.parse(err._body);
        //         error(new Status(json.systemCode, json.message));
        //     }
        // );
    }

    loginAccount (credentials:Credentials){
        return this.http.post(`${this.API}/auth`, credentials, {
            headers:{
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).
            pipe(take(1), 
            map(res => new RequestResult(true, res)), catchError(err => observableOf(new RequestResult(false, err))));
    }

    loginAccountWithToken (tokenCredential:TokenCredential, selectedCompany){
        return this.http.post(`${this.API}/auth/ucloudauth`, null, {
            headers:{
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'token': tokenCredential.token,
                'selectedCompany': selectedCompany
            }
        }).
            pipe(take(1), 
            map(res => new RequestResult(true, res)), catchError(err => observableOf(new RequestResult(false, err))));
    }

    public activateAccount(payload, success: (data) => void, error:() => void): void {
        this.restAbstractService.post<any>('activate', null, payload).subscribe(
            data => {
                success(data);
            },
            err => {
                console.log(err);
                error();
            }
        );
    }

    private login_umotion(credentials: Credentials, success: () => void, error: (status: Status) => void): void{
        this.restService.post('auth', null, credentials).subscribe(
            (data) => {
                this.authAbstractService.token = data.token;
                success();
            },
            (err) => {
                this.authAbstractService.logout();
                const json = JSON.parse(err._body);
                error(new Status(json.systemCode, json.message));
            }
        );
    }
}
